export const fromFirestore = faq => {
  return { ...faq };
};

export const toFirestore = faqToSave => {
  return {
    faq: { ...faqToSave },
  };
};
